import { application } from "../entry_points/application"

import ClearableInputController from "../controllers/clearable_input_controller"
import DrawerController from "../controllers/drawer_controller"
import DrawerGroupController from "../controllers/drawer_group_controller"
import ModalController from "../controllers/modal_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"

import SearchFormController from "../controllers/search/search_form_controller"

const setupSearchBar = (): void => {
  application.register("clearable-input", ClearableInputController)
  application.register("drawer", DrawerController)
  application.register("drawer-group", DrawerGroupController)
  application.register("search-form", SearchFormController)
  application.register("search-modal", ModalController)
  application.register("search-modal-trigger", ModalTriggerController)
}

export { setupSearchBar }
